var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangepassicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03566 18.4838C4.97746 17.7898 1.88867 14.2548 1.88867 9.99875C1.88867 5.74266 4.97746 2.20773 9.03566 1.51367",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03512 1.51367L8.15234 3.08055",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03598 1.51492L7.49609 0.585938",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9609 1.51562C16.0191 2.20969 19.1079 5.74461 19.1079 10.0007C19.1079 14.2568 16.0192 17.7917 11.9609 18.4858",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9609 18.4848L12.8437 16.918",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9609 18.4844L13.5008 19.4134",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3917 14.5702H7.60305C7.03699 14.5702 6.57812 14.1113 6.57812 13.5452V9.84328C6.57812 9.27723 7.03699 8.81836 7.60305 8.81836H13.3918C13.9578 8.81836 14.4167 9.27723 14.4167 9.84328V13.5452C14.4166 14.1113 13.9578 14.5702 13.3917 14.5702Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5078 8.81852V7.89062C13.5078 6.22945 12.1612 4.88281 10.5 4.88281C8.83883 4.88281 7.49219 6.22945 7.49219 7.89062V8.81852",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.2891V12.0998",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.17188,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepassicon);
export default __webpack_public_path__ + "static/media/changepassicon.6134fca3d7c76d42b2eb5ef02f75a1cd.svg";
export { ForwardRef as ReactComponent };